import ACLGuard from '@comp/ACLGuard';
import Loadable from '@root/routes/Loadable';
import { lazy } from 'react';

const RolesList = Loadable(lazy(() => import('@pages/roles/index')));
const CreateRole = Loadable(lazy(() => import('@pages/roles/create')));
const UpdateRole = Loadable(lazy(() => import('@pages/roles/update')));
const RoleUsers = Loadable(lazy(() => import('@pages/roles/users')));

export const rolesRoute = {
  path: 'roles',
  children: [
    {
      element: (
        <ACLGuard can={'read'}>
          <RolesList />
        </ACLGuard>
      )
    },
    {
      path: 'create',
      element: (
        <ACLGuard can={'create'}>
          <CreateRole />
        </ACLGuard>
      )
    },
    {
      path: 'id/:id',
      element: (
        <ACLGuard can={'details'}>
          <UpdateRole />
        </ACLGuard>
      )
    },
    {
      path: 'id/:id/users',
      element: (
        <ACLGuard can={'details'}>
          <RoleUsers />
        </ACLGuard>
      )
    }
  ]
};
